'use es6';

import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIBadge from 'UIComponents/badge/UIBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ShareToSlackButton({
  disabled,
  showNewBadge,
  showPanel
}) {
  return /*#__PURE__*/_jsxs(UIButton, {
    onClick: showPanel,
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "slackUiLibrary.shareToSlackButton.text"
    }), showNewBadge && /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      className: "m-bottom-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "slackUiLibrary.shareToSlackButton.newBadge"
      })
    })]
  });
}
ShareToSlackButton.propTypes = {
  disabled: PropTypes.bool,
  showNewBadge: PropTypes.bool,
  showPanel: PropTypes.func.isRequired
};
export default ShareToSlackButton;